import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=5197aa88&scoped=true&"
import script from "./Tabs.ts?vue&type=script&lang=ts&"
export * from "./Tabs.ts?vue&type=script&lang=ts&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=5197aa88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197aa88",
  null
  
)

component.options.__file = "Tabs.vue"
export default component.exports